export const TABLE_DATA = {
  heading: "MOST vs Hyperscalers",
  columns: ["OneMind MOST", "Hyperscalers (AWS/Azure/GCP)"],
  data: [
    {
      feature: "Pricing Transparency",
      "OneMind MOST": "✅ Flat-rate or usage-based",
      "Hyperscalers (AWS/Azure/GCP)": "❌ Complex tiered billing",
    },
    {
      feature: "API Access",
      "OneMind MOST": "✅ Full OpenStack access",
      "Hyperscalers (AWS/Azure/GCP)": "❌ Abstracted or limited",
    },
    {
      feature: "Platform Lock-In",
      "OneMind MOST": "✅ None",
      "Hyperscalers (AWS/Azure/GCP)": "❌ Yes (proprietary services)",
    },
    {
      feature: "Built-In Observability",
      "OneMind MOST": "✅ Yes (Elastic, Grafana)",
      "Hyperscalers (AWS/Azure/GCP)": "❌ Add-on or separate service",
    },
    {
      feature: "Support Model",
      "OneMind MOST": "✅ 24/7 with SLA",
      "Hyperscalers (AWS/Azure/GCP)": "❌ Tiered, often delayed",
    },
  ],
};
